module.exports = __webpack_public_path__ + "static/media/close-small.6b519252.svg";